import { Button } from 'antd';
import styled from 'styled-components';

// only styled customise button
const EbzButton = styled(Button)`
  background-color: #ffffff;
  border: none;
  box-shadow: 0px 3px 6px #0000000f;

  &&:hover {
    background-color: var(--color-fill-alter);
    color: var(--color-primary);
  }
`;

export default EbzButton;
